// @flow
export const TrendEnum = Object.freeze({
    Count: 'COUNT',
    Percentage: 'PERCENTAGE'
});
export type TrendEnumType = $Values<typeof TrendEnum>;

export const SentimentEnum = Object.freeze({
    Positive: 'POSITIVE',
    Negative: 'NEGATIVE'
});
export type SentimentEnumType = $Values<typeof SentimentEnum>;

export const PerformanceEnum = Object.freeze({
    Increasing: 'INCREASING',
    Decreasing: 'DECREASING'
});
export type PerformanceEnumType = $Values<typeof PerformanceEnum>;

export const TrendDirectionEnum = Object.freeze({
    Up: 'UP',
    Down: 'DOWN'
});
export type TrendDirectionEnumType = $Values<typeof TrendDirectionEnum>;

export const ChartTypeEnum = Object.freeze({
    BigNumber: 'BIGNUMBER',
    Pie: 'PIE',
    Bar: 'BAR',
    Line: 'LINE'
});
export type ChartTypeEnumType = $Values<typeof ChartTypeEnum>;
